module.exports = __webpack_public_path__ + "images/founder.4a5452c9.svg";